import E9FreqUseMenu from '../ecology9/E9FreqUseMenu';

const E8FreqUseMenu = (props) => {
    return (
        <div className="e8header-freq-use-menu">
            <E9FreqUseMenu {...props}/>
        </div>
    );
};

export default E8FreqUseMenu;


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/components/theme/ecology8/E8FreqUseMenu.js